import { Component } from '@angular/core';


/* istanbul ignore next */
/* Code coverage having problems with no statements in classes */
export class SkyPageSummaryImageComponent { static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-page-summary-image',
  template: `<div class="sky-page-summary-image">
  <ng-content></ng-content>
</div>
`,
  styles: [`@media (min-width: 768px) {
  .sky-page-summary-image {
    width: 120px;
    flex: 0 0 120px;
  }
}

@media (max-width: 767px) {
  .sky-page-summary-image {
    width: 100px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 10px;
  }
}
`]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
